import React, { useEffect } from "react";
import InputCheckbox from "../../components/InputCheckbox";
import Input from "../../components/Input";
import InputNumberOnly from "../../components/InputNumberOnly";
import { message, Row, Col, Typography, Radio } from "antd";
import { CheckCircleFilled, LoadingOutlined } from "@ant-design/icons";
import InputMask from "../../components/InputMask";
import TextAreaCopy from "components/TextAreaCopy";

import safeIcon from "assets/img/safeIcon.png";

import { createPurchase, labelsPaymentMethod, getItem } from "utils";
import { removeMask } from "utils/removeMask";

import { FiCheckCircle } from "react-icons/fi";
import badgeGooglePlay from "assets/img/badge_google-play.png";
import ios from "assets/img/ios.png";

import { useParams } from "react-router-dom";

export default function FormPayment({
  register,
  errors,
  control,
  setValue,
  onPrevious,
  getValues,
  onNext,
  loading,
  skipPayment,
}) {
  const { Text } = Typography;
  const [step, setStep] = React.useState(0);
  const [appLinks, setAppLinks] = React.useState({});
  const [loadingRequest, setLoadingRequest] = React.useState(false);
  const [paymentMethodSelected, setPaymentMethodSelected] = React.useState("");
  const [methodValues, setMethodValues] = React.useState(null);
  const [availablePaymentMethods, setAvailablePaymentMethods] = React.useState(
    []
  );
  const { paymentGroupId, currentUserId, formStep } = useParams();

  const companyName = getItem("companyName");

  React.useEffect(() => {
    const values = getValues();
    const companyId = getItem('companyId');

    const templateOrder = ["CREDIT_CARD", "BOLETO", "PIX"];

    function sortFunc(a, b) {
      return templateOrder.indexOf(a.type) - templateOrder.indexOf(b.type);
    }

    let sortedPaymentMethods =
      values.selectedPlan.paymentTypes.filter(p => p).sort(sortFunc);


    const creditCardDisabled = ["322b3a30-ad93-43b3-ae72-11bd240859b8", "05b72b7a-3316-4d27-8b71-017e0fa8162e"];
    
    if (creditCardDisabled.includes(companyId)) {
      sortedPaymentMethods = sortedPaymentMethods.filter((pm) => pm.type !== "CREDIT_CARD" )
    }

    if (skipPayment) {
      setPaymentMethodSelected("FREE");
    } else {
      setAvailablePaymentMethods(sortedPaymentMethods);
      setPaymentMethodSelected(sortedPaymentMethods[0].type);
    }

    const androidAppUrl = getItem("androidAppUrl");
    const iosAppUrl = getItem("iosAppUrl");

    setAppLinks({ androidAppUrl, iosAppUrl });
  }, []);

  useEffect(() => {
    setValue("paymentMethodSelected", paymentMethodSelected);
  }, [paymentMethodSelected]);

  const handleGeneratePayment = async (type) => {
    const formValues = getValues();
    setLoadingRequest(true);
    try {
      const {
        data: { pixString, qrCode, billet, success },
      } = await createPurchase({
        data: {
          ...(currentUserId
            ? { userId: currentUserId }
            : { taxId: removeMask(formValues.taxId) }),
          paymentId: formValues.selectedPlan.id,
          paymentType: type === 'FREE' ? 'PIX' : type,
        },
      });

      setMethodValues({
        pixString: pixString,
        qrCode: qrCode,
        billet: billet,
      });

      success && message.success("Código gerado com sucesso!");
      setLoadingRequest(false);
    } catch (err) {
      setLoadingRequest(false);

      message.error(err.response?.data?.message || err.message);
    }
  };

  const handlePayWithCreditCard = async (type) => {
    const formValues = getValues();
    setLoadingRequest(true);

    const expiryMonth = formValues.validDate.split("/")[0];
    const expiryYear = formValues.validDate.split("/")[1];

    try {
      const {
        data: { success },
      } = await createPurchase({
        data: {
          paymentId: formValues.selectedPlan.id,
          paymentType: type,
          creditCard: {
            holderName: formValues.holderName,
            number: formValues.cardNumber,
            expiryMonth: expiryMonth,
            expiryYear: expiryYear,
            ccv: formValues.securityCode,
          },
          ...(currentUserId
            ? { userId: currentUserId }
            : { taxId: removeMask(formValues.taxId) }),
        },
      });

      setMethodValues({
        creditCard: success,
      });

      success && message.success("Pagamento efetuado com sucesso!");
      setLoadingRequest(false);
    } catch (err) {
      setLoadingRequest(false);

      message.error(err.response?.data?.message || err.message);
    }
  };

  const MobileAppCTO = () => {
    return (
      <div>
        <p
          style={{
            fontSize: "16px",
            marginTop: "70px",
            textAlign: "center",
          }}
        >
          Se você ainda não tem nosso aplicativo baixe agora:
        </p>
        <div className="__signup-embed-mobile-download">
          <Row>
            <Col
              xs={24}
              md={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignSelf: "center",
                padding: "10px",
              }}
            >
              <a
                href={appLinks.iosAppUrl}
                style={{ textAlign: "center", width: "100%" }}
              >
                <img
                  alt="Download on the App Store"
                  src={ios}
                  style={{ width: "200px", maxWidth: "200px" }}
                />
              </a>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignSelf: "center",
                padding: "10px",
              }}
            >
              <a
                href={appLinks.androidAppUrl}
                style={{ textAlign: "center", width: "100%" }}
              >
                <img
                  src={badgeGooglePlay}
                  alt="Disponível no Google Play"
                  style={{ width: "200px", maxWidth: "200px" }}
                />
              </a>
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  const renderMethodValues = () => {
    const type = {
      FREE: (
        <>
          <div style={{ textAlign: "center" }}>
            <h1
              style={{
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
                marginBottom: "50px",
                color: "#000",
              }}
            >
              Vamos nessa!
            </h1>
            <h1
              style={{ fontSize: "20px", marginBottom: "50px", color: "#000" }}
            >
              Agora você pode usufruir de todos seus benefícios!
            </h1>
            <FiCheckCircle
              style={{ fontSize: "60px", color: "#31b156" }}
            ></FiCheckCircle>
          </div>
          <MobileAppCTO />
        </>
      ),
      CREDIT_CARD: (
        <>
          <div style={{ textAlign: "center" }}>
            <h1
              style={{
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
                marginBottom: "50px",
                color: "#000",
              }}
            >
              Vamos nessa!
            </h1>
            <h1
              style={{ fontSize: "20px", marginBottom: "50px", color: "#000" }}
            >
              Agora você pode usufruir de todos seus benefícios!
            </h1>
            <FiCheckCircle
              style={{ fontSize: "60px", color: "#31b156" }}
            ></FiCheckCircle>
          </div>
          <MobileAppCTO />
        </>
      ),
      PIX: (
        <>
          <h1
            style={{
              fontSize: "20px",
              textTransform: "uppercase",
              fontWeight: "bold",
              marginBottom: "50px",
              color: "#000",
            }}
          >
            Vamos nessa!
          </h1>
          <h1 style={{ fontSize: "20px", marginBottom: "50px", color: "#000" }}>
            Dá uma olhada na sua caixa de entrada pra não perder nenhum detalhe
            sobre sua conta {companyName}. E não esquece de acertar o pagamento
            pra virar um membro VIP agora mesmo!
          </h1>
          <div className="__signup-embed-container-pix-result">
            <div className="__signup-embed-pix-image">
              <img
                src={`data:image/jpeg;base64, ${methodValues?.qrCode}`}
                style={{ width: "100%", alignSelf: "flex-end" }}
              />
            </div>
            <div className="__signup-embed-pix-copy">
              <TextAreaCopy
                title="Código PIX"
                id={"pix"}
                value={methodValues?.pixString}
              />
            </div>
          </div>
          <MobileAppCTO />
        </>
      ),
      BOLETO: (
        <>
          <h1
            style={{
              fontSize: "20px",
              textTransform: "uppercase",
              fontWeight: "bold",
              marginBottom: "50px",
              color: "#000",
            }}
          >
            Vamos nessa!
          </h1>
          <h1 style={{ fontSize: "20px", marginBottom: "50px", color: "#000" }}>
            Dá uma olhada na sua caixa de entrada pra não perder nenhum detalhe
            sobre sua conta {companyName}. E não esquece de acertar o pagamento
            pra virar um membro VIP agora mesmo!
          </h1>
          <TextAreaCopy
            title="Código de barras"
            id={"billet"}
            value={methodValues?.billet}
          />
          <MobileAppCTO />
        </>
      ),
    };

    return type[paymentMethodSelected];
  };

  const renderMethodOptions = () => {
    const r = {
      FREE: (
        <Row>
          <Col xs={24}>
            <p>O plano selecionado é gratuito, não há necessidade de pagamento, clique abaixo e finalize a transação.</p>
          </Col>
        </Row>
      ),
      // CREDIT_CARD: (
      //   <>
      //     <Row gutter={6}>
      //       <Col xs={24} md={12}>
      //         <InputMask
      //           key="cardNumber"
      //           label="Número do cartão"
      //           placeholder="Digite seu número de cartão"
      //           control={control}
      //           name="cardNumber"
      //           mask="9999999999999999999"
      //           maskChar={null}
      //           required
      //           error={errors.cardNumber?.message}
      //           //   type="credit-card"
      //           style={{ ...styles.input }}
      //         />
      //       </Col>

      //       <Col xs={24} md={12}>
      //         <InputMask
      //           key="holderName"
      //           label="Nome do titular"
      //           placeholder="Digite o nome"
      //           control={control}
      //           name="holderName"
      //           maskChar={null}
      //           required
      //           error={errors.holderName?.message}
      //           //   type="credit-card"
      //           type="custom"
      //           options={{
      //             mask: "99/99",
      //           }}
      //           style={styles.input}
      //         />
      //       </Col>

      //       <Col xs={24} md={12}>
      //         <InputMask
      //           key="validDate"
      //           label="Validade"
      //           placeholder="Digite a data de validade"
      //           control={control}
      //           name="validDate"
      //           mask="99/9999"
      //           maskChar={null}
      //           required
      //           error={errors.validDate?.message}
      //           //   type="credit-card"
      //           type="custom"
      //           options={{
      //             mask: "99/99",
      //           }}
      //           style={{ ...styles.input }}
      //         />
      //       </Col>

      //       <Col xs={24} md={12}>
      //         <InputMask
      //           key="securityCode"
      //           label="CVV"
      //           placeholder="Digite seu número de cvv"
      //           control={control}
      //           name="securityCode"
      //           mask="9999"
      //           maskChar={null}
      //           required
      //           error={errors.securityCode?.message}
      //           //   type="credit-card"
      //           type="custom"
      //           style={styles.input}
      //         />
      //       </Col>
      //     </Row>

      //     <div
      //       style={{
      //         flexDirection: "row",
      //         justifyContent: "center",
      //         alignItems: "center",
      //         marginTop: 5,
      //         marginBottom: 15,
      //       }}
      //     >
      //       <img
      //         src={safeIcon}
      //         style={{
      //           width: "15px",
      //           margin: "0 10px",
      //         }}
      //       />
      //       <Text
      //         style={{
      //           textAlign: "center",
      //           fontSize: 12,
      //         }}
      //       >
      //         Pagamento seguro e protegido
      //       </Text>
      //     </div>
      //   </>
      // ),
      PIX: <></>,
      BOLETO: <></>,
    };

    return r[paymentMethodSelected];
  };

  const renderContent = () => {
    if (methodValues) {
      return renderMethodValues();
    }

    return <div style={{ marginHorizontal: 10 }}>{renderMethodOptions()}</div>;
  };

  const handleNext = async () => {
    if (paymentMethodSelected === "CREDIT_CARD") {
      (await onNext()) && handlePayWithCreditCard(paymentMethodSelected);
    } else {
      handleGeneratePayment(paymentMethodSelected);
    }
  };

  const styles = {
    screenDescription: {
      color: "var(---primary-color-text)",
      marginHorizontal: 20,
      marginBottom: 40,
      fontSize: 13,
      margin: 20,
    },
    header: {
      paddingTop: 20,
      paddingHorizontal: 20,
      flexDirection: "row",
      justifyContent: "space-between",
    },
    card: {
      flexDirection: "row",
      width: "100%",
      borderWidth: 1,
      borderRadius: 10,
      justifyContent: "space-between",
      marginBottom: 20,
      backgroundColor: "#fff",
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.2,
      shadowRadius: 5,
      elevation: 4,
    },
    divider: {
      borderBottomWidth: 1,
      borderBottomColor: "#ccc",
      margin: 20,
    },
    mainGraph: {
      position: "absolute",
      zIndex: -1,
      width: "100%",
      backgroundColor: "var(--background-color)",
    },
    cardContainer: {
      width: "90%",
      borderRadius: 10,
      backgroundColor: "#fff",
      alignSelf: "center",
      overflow: "hidden",
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowOpacity: 0.2,
      shadowRadius: 5,
      elevation: 5,
      marginBottom: 30,
    },
    containerHeadMethod: {
      borderRadius: 10,
      justifyContent: "space-between",
      backgroundColor: "#fff",
      padding: 0,
      flexDirection: "row",
      borderBottomColor: "#ccc",
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      flexWrap: "wrap",
    },
    containerMethod: {
      flexDirection: "column",
      borderRadius: 10,
      justifyContent: "space-between",
      backgroundColor: "#fff",
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.8,
      shadowRadius: 3,
      elevation: 3,
      padding: 5,
      marginHorizontal: 25,
      flexGrow: 1,
      marginBottom: 30,
    },
    infoContainer: {
      position: "absolute",
      marginLeft: 10,
      flexDirection: "column",
    },
    label: { fontSize: 14, fontWeight: "bold", marginBottom: 5 },
    input: {
      borderWidth: 2,
      borderRadius: 10,
      borderColor: "#cccccc80",
      marginBottom: 10,
    },
    name: {
      color: "#fff",
      fontWeight: "bold",
      fontSize: 15,
    },
  };

  return (
    <div key="formPayment">
      <Row gutter={16} className="__auth-mb-25">
        <>
          <div style={styles.containerMethod}>
            {!methodValues && (
              <>
                <Col xs={24} sm={24}>
                  <Text>Selecione o método de pagamento</Text>
                </Col>
                <div style={styles.containerHeadMethod}>
                  <Radio.Group
                    onChange={(event) => {
                      setPaymentMethodSelected(event.target.value);
                    }}
                    value={paymentMethodSelected}
                    className="__signup-embed-radio-group"
                  >
                    {availablePaymentMethods.map((m) => (
                      <Radio
                        key={m.type}
                        value={m.type}
                        className="__signup-embed-radio-item"
                      >
                        {labelsPaymentMethod[m.type]}
                      </Radio>
                    ))}
                  </Radio.Group>
                </div>
              </>
            )}
            <div style={{ ...styles.divider, marginVertical: 10 }} />
            {renderContent()}
          </div>
        </>
        {/* )} */}
      </Row>

      <Row gutter={16} className="__signup-bottom-button">
        {!methodValues && (
          <>
            <Col xs={12}>
              <button
                type="button"
                className="__auth-button-outlined"
                onClick={onPrevious}
                disabled={loading}
              >
                Voltar
              </button>
            </Col>
            <Col xs={12}>
              <button
                type="button"
                className="__auth-button-primary"
                disabled={loading || loadingRequest}
                onClick={handleNext}
              >
                {loading || loadingRequest ? <LoadingOutlined /> : "Finalizar"}
              </button>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
}
